import { JobRunnerTabTypes } from "./JobRunner";

interface JobRunnerTabsProps {
  tabType: JobRunnerTabTypes;
  handleTabChange: (type: JobRunnerTabTypes) => void;
}

const JobRunnerTabs = ({ tabType, handleTabChange }: JobRunnerTabsProps) => {
  return (
    <div className="function-buttons-container">
      <div className="button-container-scheme-picker">
        <div
          className={`tab-view-button ${
            tabType === JobRunnerTabTypes.CONFIG ? "active" : ""
          } first-button`}
          onClick={() => handleTabChange(JobRunnerTabTypes.CONFIG)}
        >
          Config
        </div>
        <div
          className={`tab-view-button ${
            tabType === JobRunnerTabTypes.CODE ? "active" : ""
          } middle-button`}
          onClick={() => handleTabChange(JobRunnerTabTypes.CODE)}
        >
          Code
        </div>
        <div
          className={`tab-view-button ${
            tabType === JobRunnerTabTypes.TEMPLATE ? "active" : ""
          } last-button`}
          onClick={() => handleTabChange(JobRunnerTabTypes.TEMPLATE)}
        >
          Template
        </div>
      </div>
    </div>
  );
};

export default JobRunnerTabs;
